import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  createFileRoute,
  Outlet,
  redirect,
  useNavigate,
} from '@tanstack/react-router';

import { isAuthenticated } from '@shared/utils/auth';

function AuthGuard() {
  const currentUser = useSelector(
    (state: { users: { currentUser: unknown } }) => state.users.currentUser,
  );
  const navigate = useNavigate();

  useEffect(() => {
    if (!currentUser) {
      navigate({ to: '/signin' });
    }
  }, [currentUser, navigate]);

  if (!currentUser) {
    return null;
  }

  return <Outlet />;
}

export const Route = createFileRoute('/_auth')({
  beforeLoad: () => {
    if (!isAuthenticated()) {
      throw redirect({ to: '/signin' });
    }
  },
  component: AuthGuard,
});
